import debounce from "lodash/debounce";
import { Toast } from 'antd-mobile';
import Cookies from 'js-cookie';
import tool from '@/common/utils/tool';
import { getEnv } from '@/utils/common';
import ampHandler from "@/utils/apm";

const win: any = window;

/**
 * jsbridge连接函数
 */
const connectWebViewJavascriptBridge = (callback: any) => {
  if (win?.WebViewJavascriptBridge) {
    callback(win?.WebViewJavascriptBridge);
  } else {
    document.addEventListener('WebViewJavascriptBridgeReady', function () {
      callback(win?.WebViewJavascriptBridge);
    }, false);
  }
};

/**
 * 返回上一页
 */
const handleBack = () => {
  if(getEnv().isWebInWeapp) {
    // @ts-ignore
    window.wx.miniProgram.navigateBack();
  } else {
    connectWebViewJavascriptBridge((bridge: any) => {
      bridge.callHandler('closeWebView', '', () => ({}))
    });
  }
};

/**
 * 返回首页
 */
const goHome = () => {
  if (getEnv().isApp) {
    window.location.href = 'mcdapp://page?iosPageName=MCDTabBarController&androidPageName=ComponentHome&androidPageAction=home&harmonyPageName=MainPage&parameters=%7B%22selectedIndex%22%3A%220%22%7D';
    return;
  }
};

/**
 * 跳转卡包页
 */
const toCouponList = debounce((couponInfo: any)=>{
  if(getEnv().isWebInWeapp) {
    // @ts-ignore
    window.wx.miniProgram.navigateTo({
      url: '/coupon/pages/index'
    });
  } else {
    window.location.href =
    'mcdapp://page?iosPageName=MCDMyWalletHomeViewController&androidPageName=ComponentUser&androidPageAction=coupon_list&harmonyPageName=WalletPage&parameters=' + encodeURIComponent(JSON.stringify({couponId: couponInfo.couponId}));
  }
}, 1000, { leading: true, trailing: false })

const isLogin = () => {
  return !!getSid();
}

const getSid = () => {
  return Cookies.get('sid') || tool.getSearchByKey('sid');
}

/**
 * 跳转登录
 */
const toLogin = debounce(()=>{
  if(getEnv().isWebInWeapp) {
    // @ts-ignore
    window.wx.miniProgram.redirectTo({
      url: `/login/pages/authorize/index?url=${encodeURIComponent(window.location.href)}`
    });
  } else if(getEnv().isApp) {
    window.location.href = 'https://mcd.cn/login';
  }
}, 1000, { leading: true, trailing: false });

const downloadAtOnce = debounce(() => {
  if (getEnv().isHarmony) {
    Toast.show('请至应用市场下载麦当劳APP');
    return
  }
  const document: any = window.document;
  const hidden = document.hidden || document.mozHidden || document.msHidden || document.webkitHidden;
  if (!hidden) {
    let href;
    if (getEnv().isIos) {
      href = 'https://apps.apple.com/cn/app/id1054598922';
    } else {
      href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.mcdonalds.gma.cn';
    }
    window.location.href = href;
  }
}, 1000, { leading: true, trailing: false });

/**
 * 获取APP版本号
 */
const getAppVersion = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!getEnv().isApp) {
      reject(new Error('非APP环境'));
      return;
    }
    
    connectWebViewJavascriptBridge((bridge: any) => {
      bridge?.callHandler('getAppVersion', '', (responseData: any) => {
        try {
          resolve(JSON.parse(responseData).appVersion || '');
        } catch (error) {
          console.error('获取APP版本号失败:', error);
          resolve('');
        }
      });
    });
  });
};

/**
 * 向URL添加查询参数
 * @param url 原始URL
 * @param params 要添加的参数对象
 * @returns 添加参数后的URL
 */
const addQueryParams = (url: string, params: Record<string, string | number | boolean>): string => {
  try {
    const urlObj = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        urlObj.searchParams.set(key, String(value));
      }
    });
    return urlObj.toString();
  } catch (error) {
    console.error('URL参数添加失败:', error);
    return url;
  }
};

const getCtOnlyApp = () => {
  let ct = 10;
  const userAgent: any = navigator.userAgent.toLowerCase();
  if (userAgent.includes("mcd-ios")) {
    ct = 101;
  } else if (userAgent.includes("mcd-android")) {
    ct = 102;
  } else if (userAgent.includes('mcd-harmony')) {
    ct = 103;
  }
  return ct
}

const apmUploadEvent = (event: string, data: any) => {
  try {
    ampHandler.uploadEventInfo(event, Date.now(), JSON.stringify({...data, parentCt: getCt(), sid: getSid()}));
  } catch (error) {
    console.log("uploadError", error);
  }
};

export {
  connectWebViewJavascriptBridge,
  handleBack,
  goHome,
  toCouponList,
  toLogin,
  downloadAtOnce,
  getSid,
  isLogin,
  getAppVersion,
  addQueryParams,
  getCtOnlyApp,
  apmUploadEvent,
};